export const LOGOS = [
  {
    name: 'Asana',
    logo_url: '/onboarding/asana.svg',
  },
  {
    name: 'Gumroad',
    logo_url: '/onboarding/gumroad.svg',
  },
  {
    name: 'Slack',
    logo_url: '/onboarding/slack.svg',
  },
  {
    name: 'Medium',
    logo_url: '/onboarding/medium.svg',
  },
  {
    name: 'Dropbox',
    logo_url: '/onboarding/dropbox.svg',
  },
  {
    name: 'Linear',
    logo_url: '/onboarding/linear.svg',
  },
  {
    name: 'Notion',
    logo_url: '/onboarding/notion.svg',
  },
];